module.exports = __webpack_public_path__ + "img/gfqg-logo-caption-path-primary.d56cca07.svg";